import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.assessment-id.label': {
    id: 'profile.assessment-id.label',
    defaultMessage: 'Assessment ID',
    description: 'The label for the assessment ID in a user profile.',
  },
});

export default messages;
